export default function showHideBox(wrapper) {
	if (!wrapper) return;
	
	const button = wrapper.querySelector('[data-show-hide="button"]');
	if (!button) return;
	
	const span = button.querySelector('span');
	const originalText = span.textContent;
	
	button.addEventListener('click', () => {
		wrapper.classList.toggle('is-active');
		button.classList.toggle('is-active');
		span.textContent = button.classList.contains('is-active') ? button.dataset.text : originalText;
	});
}
